/** Shared semi-transparent dim layer behind modals (not solid black). */
export const modalOverlayTintClassName = 'bg-slate-900/70 dark:bg-slate-950/78'

export const modalOverlayAnimationClassName =
  'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'

export const modalOverlayClassName = `fixed inset-0 ${modalOverlayTintClassName} ${modalOverlayAnimationClassName}`
